module.exports = __webpack_public_path__ + "static/media/noShipments.b7be54e5.svg";